import {takeUntil} from 'rxjs/operators';
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ElementRef,
    QueryList,
    ViewChildren
} from '@angular/core';
import {SurveyConfigService} from '@clients/member-direct/surveys';
import {TranslationService} from '@clients/member-direct/translation';
import {DROPDOWN_POSITION_ENUM, IDropdownData, UntilComponentDestroyed} from '@clients/shared/common-forms';
import {trackByValue} from '@clients/member-direct/surveys';

// todo create app level language-member-direct-app-language https://healthtel.atlassian.net/browse/SB-980

@Component({
    selector: 'member-direct-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent extends UntilComponentDestroyed implements OnInit {
    @ViewChildren('languageElements')
    languageElements: QueryList<ElementRef>;

    @ViewChild('languageBtn')
    languageBtn: ElementRef;

    @Input()
    public languagesData: Array<IDropdownData>;

    @Input()
    activeLanguage: string;

    @Input()
    dropdownPosition?: DROPDOWN_POSITION_ENUM = DROPDOWN_POSITION_ENUM.BOTTOM;

    @Output()
    changeHandler: EventEmitter<string> = new EventEmitter<string>();

    languageIconKey: string;
    public isActive = false;
    public label: string;
    public languageChangeText: string;
    public dialogAriaLabel: string;

    constructor(public translationService: TranslationService, public surveyConfigService: SurveyConfigService) {
        super();
    }
    ngOnInit() {
        this.surveyConfigService.surveyConfigUpdated.pipe(takeUntil(this.destroyed$)).subscribe(() => {
            this.languageIconKey = this.surveyConfigService.getUse508ComplianceDefaults()
                ? 'language-accessible'
                : 'language';
        });

        this.languageChangeText = this.languageLabelByCode(this.activeLanguage);
        this.label = this.translationService.translate('memberDirect.languages');
        this.dialogAriaLabel = this.translationService.translate('memberDirect.selectLanguage');
    }

    public menuOnClick() {
        this.toggleMenu();
        if (this.isActive) {
            const firstLang = this.languageUiElement(0);
            this.focusLanguageElement(firstLang);
        }
    }

    public toggleMenu() {
        this.isActive = !this.isActive;
    }

    public closeAndFocusBack() {
        this.toggleMenu();
        this.focusLanguageElement(this.languageBtn.nativeElement);
    }

    public onChange(value: string) {
        this.closeAndFocusBack();
        this.changeHandler.emit(value);
        this.languageChangeText = this.languageLabelByCode(value);
        this.label = this.translationService.translate('memberDirect.languages');
        this.dialogAriaLabel = this.translationService.translate('memberDirect.selectLanguage');
    }

    public onFocusLastGuardian() {
        if (this.isActive) {
            const firstLang = this.languageUiElement(0);
            this.focusLanguageElement(firstLang);
        }
    }

    public onFocusFirstGuardian() {
        if (this.isActive) {
            const lastIndex = this.languageElements.length - 1;
            const lastLang = this.languageUiElement(lastIndex);
            this.focusLanguageElement(lastLang);
        }
    }

    // Get's the language item of the drop down based on the index
    private languageUiElement(index: number) {
        const language_children = this.languageElements.get(index);
        return language_children.nativeElement;
    }

    private focusLanguageElement(element: HTMLElement) {
        // Open a new task in the render lifecicle for making sure the dropdown is rendered
        // before focusing the element
        setTimeout(() => {
            element?.focus();
        });
    }

    private languageLabelByCode(languageCode: String) {
        const language = this.languagesData.find((lang) => lang.value === languageCode);
        return language?.label;
    }

    public trackByLanguageValue = trackByValue;
}
